import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const selectDebug = (state: RootState) => state.ui.debug;

const selectA11yDevToolEnabled = createSelector(selectDebug, (debug) => debug.a11yDevToolEnabled);
const selectDebugA11yFocusOnSoftNavDisabled = createSelector(
    selectDebug,
    (debug) => debug.a11yDevToolEnabled && !debug.a11yFocusOnSoftNavigationEnabled,
);

const selectAbTestsPreviews = createSelector(selectDebug, (debug) => debug.abTestPreviews);

const selectAbTestPreviewById = createSelector(
    selectDebug,
    (_: RootState, id: string) => id,
    (debug, id) => debug.abTestPreviews[id],
);

export const debugSelectors = {
    selectDebug,
    selectA11yDevToolEnabled,
    selectDebugA11yFocusOnSoftNavDisabled,
    selectAbTestsPreviews,
    selectAbTestPreviewById,
};
